module.exports = __webpack_public_path__ + "img/cite-right.b5c2d029.svg";